import React from "react";
import { Button, Grid, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import styled from "styled-components";

const Title = styled.p`
    margin: 8px;
`;

const RedirectionSection = ({ integrationsApi }) => {
    const checkAllIntegrationsDisconnected = () => {
        return (
            integrationsApi &&
            integrationsApi.data &&
            integrationsApi.data.integrations.every(
                (integration) => integration.connected === false
            )
        );
    };

    const isUnintegrated = checkAllIntegrationsDisconnected();
    return (
        <>
            <Title>Step 3 - View your data</Title>
            <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="center"
                pt={1}
            >
                <Grid item md={6} sm={12}>
                    <Stack
                        direction="column"
                        style={{
                            paddingLeft: "164px",
                            paddingRight: "164px",
                            paddingTop: "16px",
                        }}
                    >
                        <Button
                            href="/personal-profile"
                            onClick={() => {
                                localStorage.removeItem("wizard");
                            }}
                            variant="outlined"
                            disabled={isUnintegrated}
                        >
                            View Profile
                        </Button>
                        <Typography
                            align="center"
                            style={{ fontSize: "12px", fontWeight: "300", paddingTop: "12px" }}
                        >
                            Are you an expert in React? Did you fix a bunch of bugs? Sharable stats
                            that you can embed on your website or CV.
                        </Typography>
                    </Stack>
                </Grid>
                <Grid item md={6} sm={12}>
                    <Stack
                        direction="column"
                        style={{
                            paddingLeft: "164px",
                            paddingRight: "164px",
                            paddingTop: "16px",
                        }}
                    >
                        <Button
                            href="/dashboard"
                            onClick={() => {
                                localStorage.removeItem("wizard");
                            }}
                            variant="outlined"
                            disabled={isUnintegrated}
                        >
                            View Dashboards
                        </Button>
                        <Typography
                            align="center"
                            style={{ fontSize: "12px", fontWeight: "300", paddingTop: "12px" }}
                        >
                            Adadot leverages the most complete dataset on developer work patterns to
                            provide you with personalised recommendations on how to find and
                            maintain momentum.
                        </Typography>
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
};

export default RedirectionSection;
